import { Modal } from '@economic/gaudi';
import { useCurrentUser } from '@economic/react-app';
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLocalization } from '../../shared/components/l10n/l10n';
import Loader from '../../shared/components/Loader';
import { RouteDisclosure } from '../../shared/components/RouteDisclosure';
import useQuery from '../../shared/hooks/useQuery';
import { textIds } from '../user/settings/panel';
import { InterestArea, UserPanelRegistrationInformation } from '../user/settings/panel/types';
import { parseRegistration } from '../user/settings/panel/util';
import { Wizard } from '../user/settings/panel/Wizard/Wizard';

export default function InventoryFeedbackGroupOnboarding() {
    const disclosure = <RouteDisclosure routeTrigger={'#inventory-feedback'} />;

    const user = useCurrentUser();
    const navigate = useNavigate();
    const location = useLocation();
    const loadingTexts = useLocalization(textIds);
    const userRegistrationQuery = useQuery<UserPanelRegistrationInformation>(`/user-panel`, {});

    const { loading } = userRegistrationQuery;
    const customData = parseRegistration(
        userRegistrationQuery.data.userGuid
            ? {
                  ...userRegistrationQuery.data,
                  interestAreas: [...(userRegistrationQuery.data.interestAreas || []), InterestArea.InventoryFeedbackGroup],
              }
            : {
                  name: `${user.firstName} ${user.lastName}`,
                  email: user.email,
                  phone: '',
                  city: '',
                  jobRole: '',
                  userGuid: '',
                  languages: [],
                  participation: [],
                  interestAreas: [InterestArea.InventoryFeedbackGroup],
              }
    );

    const refresh = () => navigate(location.pathname);

    if (loadingTexts || loading) {
        return <Loader />;
    }

    return (
        <Modal disclosure={disclosure} size="sm">
            {({ hide }) => (
                <Wizard
                    step={userRegistrationQuery.data.userGuid ? 1 : undefined}
                    data={customData}
                    onCancel={hide}
                    refresh={refresh}
                />
            )}
        </Modal>
    );
}
